module.exports = __webpack_public_path__ + "static/llave-abb58055b17a43013488aa273bac1664.png";